module.exports = __webpack_public_path__ + "static/media/icon-ARC.284ed035.png";